<template>
  <div class="refund-info" v-if="refundInfo">
    <div class="refund-info-top">
      <div class="form-block">
        <div class="form-title">
          <div class="flex">退款信息</div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">退款单号：</div>
            <div class="form-value ">{{ refundInfo.refundNo}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">实退金额：</div>
            <div class="form-value ">{{actualMoney}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款状态：</div>
            <div class="form-value ">{{ RefundStateLabel[refundInfo.refundState]}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">联系电话：</div>
            <div class="form-value ">{{ refundUserInfo.phone||''}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">用户名称：</div>
            <div class="form-value ">{{ refundUserInfo.realName||''}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款金额：</div>
            <div class="form-value ">{{ applyMoney}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款时间：</div>
            <div class="form-value ">{{ refundInfo.creationTime}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款类型：</div>
            <div class="form-value ">{{ RefundReasonStateLabel[refundInfo.reason]}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款原因：</div>
            <div class="form-value ">{{ refundInfo. remark}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="refund-info-bottom">
      <div class="form-block">
        <div class="form-title">
          <div class="flex">协商历史</div>
        </div>
        <div class="form-content">
          <div class="block-item" v-if="refundLogs">
            <div class="order-refund">
              <div class="log-item" v-for="(log,index) in refundLogs" :key="index">
                <div class="log-text" :class="[log.logColor]">
                  {{log.refundStateText}}（{{log.refundTypeText}}：{{log.realName}}）
                </div>
                <div class="log-sub" v-if="log.operateContent">{{log.operateContent}}</div>
                <preview-img v-if="log.attachList.length>0" :imgList="log.attachList"/>
                <div class="log-time">{{log.creationTime}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import OrderService from "../../apis/orderService";
  import {RefundReasonStateLabel, RefundState, RefundStateLabel, RefundTypeLabel} from "../../service/enum";
  import PreviewImg from "../refund/preview-img";

  export default {
    name: "refund-logs",
    components: {PreviewImg},
    props: {
      orderNo: {
        type: [String, Number],
        default: 0
      }
    },
    data() {
      return {
        refundInfo: "",
        RefundStateLabel,
        RefundReasonStateLabel
      }
    },
    computed: {
      refundLogs() {
        if (!this.refundInfo.refundLogs || !this.refundInfo.refundLogs.length) return;
        const refundLogs = this.refundInfo.refundLogs.map(item => {
          const attachList = this.refundInfo.attachList.filter(attach => attach.refundLogId == item.id);
          return {
            ...item,
            refundStateText: RefundStateLabel[item.operateState],
            refundTypeText: RefundTypeLabel[item.operateType],
            logColor: OrderService.getRefundLogColor(item.operateState),
            attachList
          }
        })
        return refundLogs;
      },

      refundUserInfo() {
        if (!this.refundInfo) return {};
        return this.refundInfo.refundUserInfo;
      },
      applyMoney() {
        if (!this.refundInfo) return "";
        return OrderService.toYuan(this.refundInfo.applyMoney) + "元";
      },
      actualMoney() {
        if (!this.refundInfo) return "";
        return OrderService.toYuan(this.refundInfo.actualMoney) + "元";
      },
    },
    methods: {

      async getRefundInfo() {
        const res = await OrderService.getRefundInfo(this.orderNo);
        this.refundInfo = res;
      },
    },
    mounted() {
      this.getRefundInfo();
    }
  }
</script>

<style scoped lang="scss">
  $blue: #1677ff;
  $red: #da1212;
  .refund-info {
    vertical-align: top;
    display: inline-block;
    box-sizing: border-box;
    width: 730px;
    border-radius: 20px;
    box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.09);
    padding: 40px 50px;
    .refund-info-top {
      .form-block {
        .form-content {
          .form-cell {
            width: 260px;
            &:nth-of-type(even) {
              min-width: 50%;
              margin-left: 40px;
            }
          }
        }
      }
    }
    .log-item {
      padding: 0 20px 20px;
      line-height: 1;
      position: relative;
      &.item-title {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        &:before {
          background-color: #666666;
        }
      }
      &.blue {
        &:before {
          background-color: $blue;
        }
      }
      &.red {
        &:before {
          background-color: $red;
        }
      }
      &::before  {
        content: "";
        position: absolute;
        top: 4px;
        left: -2px;
        width: 8px;
        height: 8px;
        background: #e5e5e5;
        border-radius: 50%;
      }
      &::after {
        content: "";
        position: absolute;
        top: 4px;
        left: 1px;
        width: 2px;
        height: 100%;
        background: #e5e5e5;
      }
      &:last-child {
        padding-bottom: 0;
        &::after {
          display: none;
        }
      }
      /*&:first-child {*/
        /*&::after {*/
          /*display: none;*/
        /*}*/
      /*}*/
      .log-text {
        font-size: 14px;
        &.blue {
          color: $blue;
        }
        &.red {
          color: $red;
        }
      }

      .log-sub {
        font-size: 13px;
        margin-top: 8px;
        color: #999999;
        line-height: 1.5;
      }
      .log-time {
        font-size: 12px;
        margin-top: 8px;
        color: #999999;
      }
    }

  }
</style>
